const {
  jStat,
} = require('jstat');
const {
  round,
} = require('../utils');

export function normalDistribution(z) {
  if (isNaN(z)) return null;
  const mean = 0;
  const sd = 1;
  return jStat.normal.cdf(z, mean, sd);
}
// arqd is the annual rate of quarterly dividends
export function calculatePresentValueOfStockExDividend(stockPrice, arqd, term) {
  return stockPrice / Math.pow(1 + arqd / 4, 4 * term);
}
export function calculateCumulativeVolatility(volatility, term) {
  return volatility * Math.sqrt(term);
}
export function calculateIntermediateExcercisePrice(exercisePrice, discountRate, term) {
  return exercisePrice * Math.exp(-1 * discountRate * term);
}
export function calculateCallProportionStockPresentValue(cumulativeVolatility, pvIntermediateExcersizePrice,
    pvStockExDividend) {
  // let tmp = (100 / cumulativeVolatility) *
  //     Math.log(pvStockExDividend/ pvIntermediateExcersizePrice) +
  //     cumulativeVolatility / 200;
  // return normalDistribution(tmp);
  const tmp = Math.log(pvStockExDividend / pvIntermediateExcersizePrice) / cumulativeVolatility +
    cumulativeVolatility / 2;
  return normalDistribution(tmp);
}
export function calculateCallProportionExcercisePricePV(cumulativeVolatility, pvIntermediateExcersizePrice,
    pvStockExDividend) {
  const tmp = Math.log(pvStockExDividend / pvIntermediateExcersizePrice) / cumulativeVolatility -
    cumulativeVolatility / 2;
  return normalDistribution(tmp) * -1;
}

export function calculateCallOptionValue(pvStockExDividend, pvExercisePrice, callStockPV, callExerciesePV) {
  return pvStockExDividend * callStockPV + pvExercisePrice * callExerciesePV;
}

export function convertAndPerformCalculation(row) {
  // This function is used to get row data and then calculate
  // Discount rate will be entered as 2.04 and we need to consider it as .0204
  const calculatorRow = {
    ...row,
  };
  if (calculatorRow.discount_rate) {
    calculatorRow.discount_rate = calculatorRow.discount_rate / 100;
  }
  if (calculatorRow.volatility) {
    calculatorRow.volatility = calculatorRow.volatility / 100;
  }
  return calculateValues(calculatorRow);
}

export function calculateValues(row) {
  const intermediate = {};
  const callOptions = {};
  let putOptions = {};
  const outputs = {};

  // calculate intermediate values, round() values for display and saving
  intermediate.pved = calculatePresentValueOfStockExDividend(row.stock_price, row.arqd, row.term);

  const pvee = calculateIntermediateExcercisePrice(row.exercise_price, row.discount_rate, row.term);
  intermediate.pvee = round(pvee);
  const cv = calculateCumulativeVolatility(row.volatility, row.term);
  intermediate.cv = round(cv * 100);

  // calculate Calloption Values , round() values for display and saving
  // let pspvTemp =
  //     (100 / cv) *
  //     Math.log(intermediate.pved / pvee) +
  //     cv / 200;
  // let pspv = normalDistribution(pspvTemp);
  const pspv = calculateCallProportionStockPresentValue(cv, pvee, intermediate.pved);

  // let peppTemp =
  //     (100 / cv) *
  //     Math.log(intermediate.pved / pvee) -
  //     cv / 200;
  // let pepp = normalDistribution(peppTemp);
  const pepp = calculateCallProportionExcercisePricePV(cv, pvee, intermediate.pved);

  callOptions.pspv = round(pspv);
  callOptions.pepp = round(pepp);
  const value = calculateCallOptionValue(intermediate.pved, pvee, pspv, pepp);
  callOptions.value = round(value);

  // calculate putOption values , round() values for display and saving
  putOptions = Object.assign(callOptions);

  // caculate OutputValue
  const ecofv = value;
  outputs.ecofv = callOptions.value;

  const epofv = ecofv + pvee - row.stock_price;
  outputs.epofv = round(epofv);

  const valueDiscount = row.stock_price * 0.15;
  outputs.value_discount = round(valueDiscount);

  const value85Call = ecofv * 0.85;
  outputs.value_85_call = round(value85Call);

  const value15Put = epofv * 0.15;
  outputs.value_15_put = round(value15Put);

  outputs.total_value_per_share =
    valueDiscount + value85Call + value15Put;

  const trancheObject = {
    intermediate: intermediate,
    callOptions: callOptions,
    putOptions: putOptions,
    outputs: outputs,
  };
  // console.log("trancheObject", trancheObject);
  return trancheObject;
}
